
  
  export const getApiBaseUrl = () => {

    const host = window.location.hostname;
  
    if (host.includes('localhost')) return 'http://localhost:8080';
    else if (host.includes('dev')) return 'https://dev-oe-api.com';
    else if (host.includes('stage')) return 'https://stage-oe-api.com';
    else return 'https://oe-api.com';
   
  };
  